"use client"

import { useState } from "react"
import { Loader2 } from "lucide-react"
import { subscribeToRestock } from "@lib/data/restock"

export default function NotifyMeButton({
  variantId,
  isLoggedIn,
}: {
  variantId: string | undefined
  isLoggedIn: boolean
}) {
  const [showEmailField, setShowEmailField] = useState(false)
  const [email, setEmail] = useState("")
  const [status, setStatus] = useState<"idle" | "loading" | "done" | "error">("idle")
  const [error, setError] = useState<string | null>(null)

  const handleSubscribe = async () => {
    if (!variantId) return
    if (!isLoggedIn && !showEmailField) {
      setShowEmailField(true)
      return
    }
    if (!isLoggedIn && !email) {
      setError("Please enter your email.")
      return
    }

    setStatus("loading")
    setError(null)
    const result = await subscribeToRestock(variantId, isLoggedIn ? undefined : email)
    if (result.success) {
      setStatus("done")
    } else {
      setStatus("error")
      setError(result.error)
    }
  }

  if (status === "done") {
    return (
      <div className="w-full h-14 rounded-lg border border-green-500 text-green-600 flex items-center justify-center font-semibold">
        You&apos;ll be notified when it&apos;s back
      </div>
    )
  }

  return (
    <div className="w-full flex flex-col gap-2">
      {showEmailField && !isLoggedIn && (
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="you@example.com"
          className="w-full h-12 rounded-lg border border-gray-300 px-4 text-base"
        />
      )}
      <button
        onClick={handleSubscribe}
        disabled={!variantId || status === "loading"}
        className="w-full h-14 rounded-lg bg-brand-hero-navy text-white text-lg font-bold hover:bg-brand-navy disabled:opacity-50 disabled:cursor-not-allowed transition-colors flex items-center justify-center gap-2"
      >
        {status === "loading" && <Loader2 className="w-5 h-5 animate-spin" />}
        {showEmailField && !isLoggedIn ? "Notify me" : "Notify me when back in stock"}
      </button>
      {error && <p className="text-red-500 text-sm">{error}</p>}
    </div>
  )
}
